// Import External Modules
import { AxiosResponse } from "axios";

// Import API
import Api from "../services/Api";

// Import Models
import { ListOfRecipesResponse } from "@/models/responses.model";
import { RecipeSchema } from "@/models/recipe.model";

const RecipeService = {
  getAllRecipes(params: any) {
    const tags = params.tags.length ? params.tags.toString() : null;
    return new Promise((resolve, reject) => {
      Api()
        .get("recipes", {
          params: {
            ...params,
            tags
          }
        })
        .then((response: AxiosResponse<ListOfRecipesResponse>) => {
          const data = response.data;

          if (response.status !== 200) {
            return reject(response.status);
          }

          if (
            data.meta.perfect_matches !== null &&
            data.meta.perfect_matches > 0
          ) {
            data.data = data.data.filter(
              item => item.matchType === "perfect" || item.matchType === null
            );
          } else if (tags !== null) {
            data.data = [];
          }

          resolve(data);
        })
        .catch(err => console.error(err));
    });
  },
  getSingleRecipe(id: string): Promise<RecipeSchema> {
    return new Promise((resolve, reject) => {
      Api()
        .get(`recipes/${id}`)
        .then(response => {
          if (response.status !== 200) {
            return reject(response.status);
          }
          resolve(response.data as RecipeSchema);
        })
        .catch(err => console.error(err));
    });
  },
  getRecipeSlides() {
    return new Promise((resolve, reject) => {
      Api()
        .get("slideshow")
        .then((response: any) => {
          const data = response.data;
          resolve(data);
        })
        .catch(err => console.error(err));
    });
  },
  getAllGroups(filterQuery?: any) {
    return new Promise((resolve, reject) => {
      Api()
        .get("groups", {
          params: filterQuery
        })
        .then(response => {
          if (response.status !== 200) {
            return reject(response.status);
          }

          resolve(response.data);
        });
    });
  }
};

export default RecipeService;
